<kuv-loading></kuv-loading>
<kuv-alert></kuv-alert>

<div class="container-fluid p-5">
    <h3>Gestión de Productos</h3>
    <div class="btn btn-primary my-2" (click)="agregar()"><i class="fas fa-plus-circle me-2"></i>Registrar Nuevo
        Producto</div>
    <kuv-lazy-table [url]="config.apiUrl + 'producto/index/' " [columnas]="columnas" [acciones]="acciones"
        [reloadEmitter]="reloadEmitter" [hasShadow]="true" [headers]="sesion.headers"
        [urlExcel]="config.apiUrl + 'producto/excel'" [headersBlob]="sesion.headersBlob" [filtros]="filtros"
        [isRounded]="true"></kuv-lazy-table>
</div>